import React, { useEffect, useState } from 'react';
import { AnyIfEmpty, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import iconClose from '../../../images/icon-close.svg';
import { addAdminLocation, getInvitedAdminList } from '../../../redux/invited-locations/actions/invitedLocation.actions';
import { AppDispatch, IRootState } from '../../../redux/rootReducer';
import Loader from '../../common/loader/Loader';
import styles from './ShareLocation.module.css';

interface AdminProps {
    fullName: string;
    color: () => void;
    id: string;
}

interface Props {
    setOpen: (open: boolean) => void;
}

const ShareLocation = ({ setOpen }: Props) => {
    const dispatch: AppDispatch = useDispatch();
    const { id } = useParams();

    const user = localStorage.getItem('user') || '';

    useEffect(() => {
        dispatch(getInvitedAdminList(id, JSON.parse(user)?.id));
    }, [id]);

    const adminData = useSelector((state: IRootState) => state.invitedLocations.data?.userList);
    const addAdminLoader = useSelector((state: IRootState) => state.invitedLocations.addAdminLocation.loading);
    const invitedAdminList = useSelector((state: IRootState) => state.invitedLocations.invitedAdmin.data?.data);

    const generateDarkColorHex = () => {
        let color = '#';
        for (let i = 0; i < 3; i++) color += ('0' + Math.floor((Math.random() * Math.pow(16, 2)) / 2).toString(16)).slice(-2);
        return color;
    };

    const [people, setPeople]: AnyIfEmpty<object> = useState([{}]);
    const [searchAdmin, setSearchAdmin] = useState('');
    const [searchAdminList, setSearchAdminList]: AnyIfEmpty<object> = useState([]);
    const [invitedAdmins, setInvitedAdmins] = useState([{}]);
    useEffect(() => {
        setSearchAdmin('');
        setSearchAdminList([]);
        setInvitedAdmins([{}]);
    }, []);

    useEffect(() => {
        const adminData = setTimeout(() => {
            // dispatch(getAdminSearchList());
        }, 2000);

        () => clearInterval(adminData);
    }, [searchAdmin]);

    useEffect(() => {
        const data = adminData?.filter(
            (admin: AdminProps) => !invitedAdmins.some((el: AnyIfEmpty<object>) => el.fullName == admin.fullName),
        );

        const sortResult = data?.sort((a: AdminProps, b: AdminProps) => (a.fullName > b.fullName ? 1 : b.fullName > a.fullName ? -1 : 0));

        setSearchAdminList(sortResult);
    }, [searchAdmin, adminData]);

    useEffect(() => {
        const tempArr = [{}];

        invitedAdminList?.map((admin: AdminProps) =>
            tempArr.push({
                ...admin,
                color: generateDarkColorHex(),
            }),
        );

        setInvitedAdmins(tempArr);
    }, [invitedAdminList]);

    useEffect(() => {
        const removedAdminName = searchAdminList.filter(
            (admin: AdminProps) => !people.some((secondArr: AdminProps) => admin.id == secondArr.id),
        );

        setSearchAdminList(removedAdminName);
    }, [people]);

    const removePeopleHandler = (person: AdminProps) => {
        const tempArr = [...searchAdminList, person];

        const result = tempArr?.sort((a: AdminProps, b: AdminProps) => (a.fullName > b.fullName ? 1 : b.fullName > a.fullName ? -1 : 0));

        setPeople(people.filter((item: AdminProps) => item.id !== person.id));

        setSearchAdminList(result);
    };

    const addAdminHandler = (adminName: string, id: string) => {
        const tempArr = [...people];

        tempArr.push({
            fullName: adminName,
            color: generateDarkColorHex(),
            id,
        });

        setPeople(tempArr);
    };

    const inviteAdminHandler = async () => {
        const newArray = people.filter((value: AdminProps) => Object.keys(value).length !== 0);

        const obj = {
            adminId: JSON.parse(user)?.id,
            locationId: id,
            inviteUser: newArray?.map((el: AdminProps) => el.id),
        };

        dispatch(addAdminLocation(obj));

        await setPeople([{}]);

        await setSearchAdminList([]);

        setSearchAdmin('');
    };

    // const removeAdminHandler = (adminid: string) => {
    // dispatch(removeInvitedAdminList(adminid));
    // };

    return (
        <>
            {addAdminLoader && <Loader />}
            <div className={styles.modalContainer}>
                <div className={styles.header}>
                    <h2 className={styles.title}>Share Property</h2>
                    <img onClick={() => setOpen(false)} className={styles.close} src={iconClose} alt="Close" />
                </div>
                <div className={styles.modalBody}>
                    <div className={styles.invitePeople}>
                        <div className={styles.inputWrapper}>
                            <div className={styles.searchContainer}>
                                <div className={styles.people}>
                                    {people &&
                                        people?.map((person: AnyIfEmpty<object>, index: number) => (
                                            <>
                                                {Object.keys(person)?.length !== 0 ? (
                                                    <p key={index} className={styles.person}>
                                                        <span className={styles.initial} style={{ backgroundColor: person.color }}>
                                                            {person.fullName[0]}
                                                        </span>
                                                        {person.fullName}
                                                        <span className={styles.close}>
                                                            <img
                                                                onClick={() => removePeopleHandler(person)}
                                                                className={styles.remove}
                                                                src={iconClose}
                                                                alt="Close"
                                                            />
                                                        </span>
                                                    </p>
                                                ) : (
                                                    ''
                                                )}
                                            </>
                                        ))}

                                    <input
                                        type="email"
                                        placeholder="Type"
                                        value={searchAdmin}
                                        onChange={(e) => setSearchAdmin(e.target.value)}
                                    />
                                </div>
                            </div>
                            <button onClick={inviteAdminHandler} className={`${styles.invite}`}>
                                Invite
                            </button>
                        </div>
                    </div>

                    {searchAdminList?.length ? (
                        <>
                            <div className={styles.searchAdmin}>
                                {searchAdminList.map((el: AdminProps) => (
                                    <option onClick={() => addAdminHandler(el.fullName, el.id)} key={el.id}>
                                        {el.fullName}
                                    </option>
                                ))}
                            </div>
                        </>
                    ) : (
                        ''
                    )}
                    <div className={styles.invitedPeople}>
                        <p>People who has access to this property</p>
                        <ul className={styles.peopleList}>
                            {invitedAdmins?.map((admin: AnyIfEmpty<object>) => (
                                <>
                                    {Object.keys(admin).length !== 0 ? (
                                        <li>
                                            <p className={styles.personName}>
                                                <span className={styles.initials} style={{ backgroundColor: admin.color }}>
                                                    {admin.fullName[0]}
                                                </span>{' '}
                                                {admin.fullName}
                                            </p>
                                            {/* onClick={() => removeAdminHandler(admin.id)}  */}
                                            <span className={styles.remove}>Remove</span>
                                        </li>
                                    ) : (
                                        ''
                                    )}
                                </>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ShareLocation;
